import React from "react";

class AppComponent extends React.Component {
  onMount() {
    this.mounted = true;
  }
  onUnmount() {
    this.mounted = false;
  }

  componentDidMount() {
    this.onMount();
  }
  componentWillUnmount() {
    this.onUnmount();
  }

  state = {};
  mounted = true;

  setAsyncState(x) {
    return new Promise((resolve) => {
      if (!this.mounted) return resolve(null);

      this.setState(x, () => resolve(x));
    });
  }
}

export class PureAppComponent extends React.PureComponent {
  onMount() {
    this.mounted = true;
  }
  onUnmount() {
    this.mounted = false;
  }

  componentDidMount() {
    this.onMount();
  }
  componentWillUnmount() {
    this.onUnmount();
  }

  state = {};
  mounted = true;

  setAsyncState(x) {
    return new Promise((resolve) => {
      if (!this.mounted) return resolve(null);

      this.setState(x, () => resolve(x));
    });
  }
}

export default AppComponent;
